import { Component, cloneElement, h, options, render } from 'preact';

var map = function map(children, fn, ctx) {
  if (children == null) {
    return children;
  }

  children = toArray(children);

  if (ctx && ctx !== children) {
    fn = fn.bind(ctx);
  }

  return children.map(fn);
};

var forEach = function forEach(children, fn, ctx) {
  if (children == null) {
    return;
  }

  children = toArray(children);
  if (ctx && ctx !== children) {
    fn = fn.bind(ctx);
  }

  children.forEach(fn);
};

var count = function count(children) {
  return children && children.length || 0;
};

var only = function only(children) {
  children = toArray(children);

  if (children.length !== 1) {
    throw new Error('Children.only() expects only one child.');
  }

  return children[0];
};

var toArray = function toArray(children) {
  return children == null ? [] : [].concat(children);
};

var Children = Object.freeze({
	map: map,
	forEach: forEach,
	count: count,
	only: only,
	toArray: toArray
});

var createElement = h;
var VNodeCtor = h("a", null).constructor;

// React VNode has the `type` property instead of `nodeName`
Object.defineProperty(VNodeCtor.prototype, "type", {
  get: function get() {
    return this.nodeName;
  },
  set: function set(v) {
    this.nodeName = v;
  },

  configurable: true
});

// React VNode has the `prop` property instead of `attributes`
Object.defineProperty(VNodeCtor.prototype, "props", {
  get: function get() {
    return this.attributes;
  },
  set: function set(v) {
    this.attributes = v;
  },

  configurable: true
});

var isValidElement = function isValidElement(maybeElement) {
  return !!maybeElement && maybeElement instanceof VNodeCtor;
};

var oldVnode = options.vnode;

/**
 * Compatibility with Function as Child Component. react-router requires this.
 *
 * React exports sigle-children as-is, instead of wrapping them in an array as
 * preact does. We do this for single-element functions to suppport FaCC.
 */
options.vnode = function (vnode) {
  if (vnode.children.length === 1 && typeof vnode.children[0] === "function") {
    vnode.children = vnode.children[0];
  }

  if (typeof oldVnode === "function") {
    oldVnode(vnode);
  }
};

function findDOMNode(component) {
  return component && component.base;
}

var index = {
  Children: Children,
  Component: Component,
  cloneElement: cloneElement,
  createElement: createElement,
  findDOMNode: findDOMNode,
  h: h,
  isValidElement: isValidElement,
  options: options,
  render: render
};

export { Children, Component, cloneElement, createElement, findDOMNode, h, isValidElement, options, render };
export default index;
